import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../axiosinstance";
import { IoIosSearch } from "react-icons/io";
import { LuPlus } from "react-icons/lu";
import { CiCircleInfo, CiEdit } from "react-icons/ci";
import { IoCloseOutline } from "react-icons/io5"; // Ensure correct icon import
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import "./Table.css";
import { CiMenuBurger } from "react-icons/ci";
import Pagination from "../Components/Pagination";
import { MdSort } from "react-icons/md"; // Import the sort icon
import { TbSortDescending } from "react-icons/tb";
import { FiFilter } from "react-icons/fi"; // Light sort icon
import { PiSortAscendingThin } from "react-icons/pi";
import { FiUserCheck, FiUserPlus, FiUsers } from "react-icons/fi";

const ClientManagement = ({ isSidebarExpanded }) => {
  const [clients, setClients] = useState([]);
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFirms, setSelectedFirms] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const navigate = useNavigate();
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const containerRef = useRef();
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalRecords, settotalRecords] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Initially true
  const [highlights, setHighlights] = useState({});

  // Fetch all clients
  // const ITEMS_PER_PAGE = 50;
  const [searchPage, setSearchPage] = useState(1);

  const handleDeletePopup = () => {
    setIsDeletePopup(true);
  };

  const handleCancel = () => {
    setIsDeletePopup(false);
  };
  // const fetchClients = async (status = "Active", currentPage = 1) => {
  //   const authKey = localStorage.getItem("authKey");

  //   try {
  //     const response = await axios.get(
  //       `${API_URL}/api/get_all_clients?page_status=${status}`,
  //       {
  //         headers: { Authorization: `Bearer ${authKey}` },
  //         params: {
  //           page: Math.max(1, currentPage), // Ensure at least page 1
  //           per_page: ITEMS_PER_PAGE, // Fetch only 5 records per page
  //         },
  //       }
  //     );
  //     setClients(response.data.data);
  //     settotalRecords(response.data.Total_records || 0);
  //   } catch (error) {
  //     console.error("Error fetching clients data:", error);
  //   }
  // };

  const fetchClients = async (
    status = "Active",
    currentPage = 1,
    perPage = itemsPerPage
  ) => {
    setIsLoading(true); // Start loading before API call

    try {
      const response = await axiosInstance.get(
        `/api/get_all_clients?page_status=${status}`,
        {
          params: {
            page: Math.max(1, currentPage),
            per_page: perPage,
          },
        }
      );

      const fetchedClients = response.data.data || [];
      setClients(fetchedClients);
      settotalRecords(response.data.Total_records || 0);
    } catch (error) {
      console.error("Error fetching clients data:", error);
      setClients([]); // Ensure no clients are displayed on error
    } finally {
      setIsLoading(false); // Stop loading after API response
    }
  };

  

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500); // Delay API call by 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    if (debouncedSearch.trim()) {
      handleSearch({ target: { value: debouncedSearch } }, page, itemsPerPage);
    } else {
      fetchClients("Active", page, itemsPerPage);
    }
  }, [debouncedSearch, page, itemsPerPage]);

  // Handle creating a new client
  const handleClientManagement = () => {
    navigate("/client-management-form");
  };

  // Handle editing an existing client
  const handleEdit = (clientId) => {
    navigate(`/edit-client-management/${clientId}`);
  };

  // const handleSort = (key) => {
  //   // If the same column is clicked again, toggle the direction.
  //   let direction = "asc";
  //   if (sortConfig.key === key && sortConfig.direction === "asc") {
  //     direction = "desc";
  //   }

  //   const sortedRecords = [...clients].sort((a, b) => {
  //     let aValue = a[key];
  //     let bValue = b[key];

  //     // Compare the values and return the sort order.
  //     if (aValue < bValue) return direction === "asc" ? -1 : 1;
  //     if (aValue > bValue) return direction === "asc" ? 1 : -1;
  //     return 0;
  //   });

  //   // Update the sort configuration and set the sorted clients
  //   setSortConfig({ key, direction });
  //   setClients(sortedRecords);
  // };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedRecords = [...clients].sort((a, b) => {
      let aValue, bValue;

      // Special handling for contact person name sorting
      if (key === "contact_details") {
        aValue =
          a.contact_details?.find((c) => c.is_primary)?.contact_name || "";
        bValue =
          b.contact_details?.find((c) => c.is_primary)?.contact_name || "";
      } else {
        aValue = a[key];
        bValue = b[key];
      }

      // Case-insensitive string comparison
      aValue = typeof aValue === "string" ? aValue.toLowerCase() : aValue;
      bValue = typeof bValue === "string" ? bValue.toLowerCase() : bValue;

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortConfig({ key, direction });
    setClients(sortedRecords);
  };

  // Handle search functionality
  // const handleSearch = async (e) => {
  //   const query = e.target.value;
  //   setSearchQuery(query);

  //   if (!query.trim()) {
  //     fetchClients();
  //     return;
  //   }

  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const response = await axios.get(`${API_URL}/api/search_clients`, {
  //       params: {
  //         query,
  //         page_status: "Active", // Correctly passing page_status as a query parameter
  //       },
  //       headers: { Authorization: `Bearer ${authKey}` },
  //     });

  //     setClients(response.data.data || []);
  //   } catch (error) {
  //     console.error("Error fetching search results:", error.message);
  //   }
  // };

  // const handleSearch = async (e, page = 1, per_page = ITEMS_PER_PAGE) => {
  //   const query = e.target.value;
  //   setSearchQuery(query);
  //   setPage(page);
  //   setItemsPerPage(per_page);

  //   if (!query.trim()) {
  //     fetchClients("Active", 1, per_page); // Reset if search is empty
  //     return;
  //   }

  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const response = await axios.get(`${API_URL}/api/search_clients`, {
  //       params: {
  //         query,
  //         page_status: "Active",
  //         page: Math.max(1, page),
  //         per_page,
  //       },
  //       headers: { Authorization: `Bearer ${authKey}` },
  //     });

  //     const clientsData = response.data.data || [];
  //     const totalRecordsCount = response.data.Total_records ?? clientsData.length; // Ensure totalRecords is updated correctly

  //     setClients(clientsData);
  //     settotalRecords(totalRecordsCount); // Fix: Set total records properly

  //     // Ensure we don't show "Page 0 of 0"
  //     if (totalRecordsCount > 0 && page < 1) {
  //       setPage(1);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching search results:", error.message);
  //   }
  // };

  const handleSearch = async (e, newPage = 1, per_page = itemsPerPage) => {
    const query = e.target.value;
    setSearchQuery(query);

    // If query is empty, fetch all clients
    if (!query) {
      fetchClients("Active", newPage, per_page);
      return;
    }

    // Only in search mode we care about page / per_page for search API
    if (newPage !== page) {
      setPage(newPage);
    }
    if (per_page !== itemsPerPage) {
      setItemsPerPage(per_page);
    }

    try {
      const response = await axiosInstance.get(`/api/search_clients`, {
        params: { query, page_status: "Active", page: newPage, per_page },
      });

      let clientsData = response.data.data || [];
      const totalRecordsCount =
        response.data.Total_records ?? clientsData.length;

      clientsData = clientsData.map((client, index) => ({
        ...client,
        serial_number: (newPage - 1) * per_page + index + 1,
      }));

      setClients(clientsData);
      settotalRecords(totalRecordsCount);

      if (totalRecordsCount > 0 && newPage < 1) {
        setPage(1);
      }
    } catch (error) {
      console.error("Error fetching search results:", error.message);
    }
  };

  // Select/Deselect all clients
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedFirms([]);
    } else {
      setSelectedFirms(clients.map((client) => client.client_id));
    }
    setSelectAll(!selectAll);
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (clientId) => {
    setSelectedFirms((prevSelected) =>
      prevSelected.includes(clientId)
        ? prevSelected.filter((id) => id !== clientId)
        : [...prevSelected, clientId]
    );
  };

  const handleArchiveClient = async () => {
    if (selectedFirms.length === 0) {
      alert("Please select at least one firm to archive.");
      return;
    }

    try {
      const response = await axiosInstance.put(`/api/archive_clients`, {
        ids: selectedFirms,
      });

      if (response.status === 200) {
        console.log("succes");
        await fetchClients(); // Refresh client list after archiving
        setSelectedFirms([]);
        setSelectAll(false);
      } else {
        alert(
          response.data.message || "Failed to archive firms. Please try again."
        );
      }
    } catch (error) {
      console.error("Error archiving firms:", error);
      alert(
        error.response?.data?.message ||
        "An unexpected error occurred while archiving firms."
      );
    } finally {
      setIsDeletePopup(false); // Ensure popup closes after action
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsSortPopup(false);
      }
    };

    // Add event listener when the popup is open
    if (isSortPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSortPopup]);

  const handleSortpopup = (event) => {
    event.stopPropagation();
    setIsSortPopup(!isSortPopup);
  };

  const handleArchivedTable = () => {
    navigate("/archived-clients");
  };
  const handlePaginationChange = (newPage, itemsPerPage) => {
    console.log("Pagination Change - Current Page:", newPage);
    setPage(newPage);
    setItemsPerPage(itemsPerPage);
  };

  useEffect(() => {
    axiosInstance
      .get(`/api/get_client_highlights`)
      .then((response) => setHighlights(response.data))
      .catch((error) => console.error("Error fetching highlights:", error));
  }, []);

  return (
    <div
      className={`table-container client-page-layout client-management-page ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-header">
        {selectedFirms.length > 0 ? (
          <div className="table-header-content archive-header">
            <button className="delete" onClick={handleDeletePopup}>
              Move to Archive
            </button>

            <button
              className="action-header-close-button"
              onClick={() => setSelectedFirms([])}
            >
              <IoCloseOutline className="action-header-close-icon" />
            </button>
          </div>
        ) : (
          <div className="table-header-content">
            <div className="table-left-side">
              <h2 className="jost-bold">Client Management</h2>
            </div>
            <div className="table-right-side">
              {/* <div className="search-bar">
                <IoIosSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Search Clients..."
                  value={searchQuery}
                  onChange={handleSearch} // Use handleSearch to update search query and fetch data
                />
              </div> */}

              <div className="search-bar-container">
                <input
                  type="text"
                  placeholder="Search ..."
                  className="search-bar"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)} // Use handleSearch to update search query and fetch data
                />
                <IoIosSearch className="search-bar-icon" />
              </div>

              <div className="new-button" onClick={handleClientManagement}>
                <span className="new-icon">
                  <LuPlus />
                </span>
                <span>New</span>
              </div>

              <button className="client-sort-button" onClick={handleSortpopup}>
                <span className="action-icon custom-action-icon-size">
                  <PiSortAscendingThin />
                </span>
              </button>

              {isSortPopup && (
                <div className="sort-popup-container" ref={containerRef}>
                  <div className="sort-popup-header">
                    <span className="sort-title">Sort By</span>
                  </div>
                  <div className="sort-popup-content">
                    <button
                      className="sort-button"
                      onClick={() => handleSort("clients_company_name")}
                    >
                      Client Company Name
                    </button>
                    <button
                      className="sort-button"
                      onClick={() => handleSort("contact_details")}
                    >
                      Contact Person Name
                    </button>
                    <button
                      className="sort-button"
                      onClick={() => handleSort("subsidiary_company")}
                    >
                      Billing Company
                    </button>
                  </div>
                  <button
                    className="archive-button"
                    onClick={handleArchivedTable}
                  >
                    Archived Clients
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="dashboard client-summary-dashboard">
        <div className="cards-client client-summary-cards">
          <div className="card-client client-summary-card ledger-summary-card client-summary-total">
            <span className="ledger-summary-icon" aria-hidden="true">
              <FiUsers />
            </span>
            <div className="ledger-summary-copy">
              <p className="title">Total Clients</p>
              <h3>{highlights.total || 0}</h3>
            </div>
          </div>
          <div className="card-client card-text-two client-summary-card ledger-summary-card client-summary-active">
            <span className="ledger-summary-icon" aria-hidden="true">
              <FiUserCheck />
            </span>
            <div className="ledger-summary-copy">
              <p className="title">Active Clients</p>
              <h3>{highlights.active || 0}</h3>
            </div>
          </div>
          <div className="card-client dark client-summary-card ledger-summary-card client-summary-new">
            <span className="ledger-summary-icon" aria-hidden="true">
              <FiUserPlus />
            </span>
            <div className="ledger-summary-copy">
              <p className="title">New Clients added in {highlights.month}</p>
              <h3>{highlights.created_this_month || 0}</h3>
            </div>
          </div>
        </div>
      </div>
      {isDeletePopup && (
        <div className="confirm-delete-popup">
          <div className="confirm-delete-popup-content">
            <div className="confirm-model">
              <div className="confirm-model-content">
                <div className="confirm-model-content-body">
                  <p>
                    Archiving this client will also archive all their invoices,
                    ledgers, and recorded payments. Please ensure you want to
                    proceed
                  </p>
                </div>
                <div className="confirm-model-content-footer">
                  <button
                    className="confirm-delete-button"
                    onClick={handleArchiveClient}
                  >
                    Yes
                  </button>
                  <button
                    className="confirm-cancel-button"
                    onClick={handleCancel}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="data-list-body ledger-data-list-body pb0">
        <div className="data-list-scroll-body ledger-scroll-body">
          {/* <div className="data-list-table"> */}
            <table className="table multilevel-data client-management-table">
              <thead className="sticky-header">
                <tr className="table-row">
                  <th>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th>Sr. No</th>
                  <th>
                    <span style={{
                      textAlign: 'left',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}>Client Company Name</span>
                  </th>
                  <th>
                    <span style={{
                      textAlign: 'left',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}>Contact Person Name</span>
                  </th>
                  <th>
                    <span style={{
                      textAlign: 'left',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}>Billing Company</span>
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="6" className="center-align">
                      Loading Clients...
                    </td>
                  </tr>
                ) : clients.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="center-align">
                      No Clients Found
                    </td>
                  </tr>
                ) : (
                  clients.map((client, index) => {
                    const contactPersonName =
                      client.contact_details?.[0]?.contact_name || "NA";
                    const contactEmail =
                      client.contact_details?.[0]?.contact_email ||
                      "Not Available";
                    const contactAddress = `${client.office_number || "NA"}, ${client.landmark || "NA"
                      }, ${client.area || "NA"}, ${client.pin || "NA"}`;

                    return (
                      <tr key={client.client_id} className="hoverable-row">
                        <td className="center-align">
                          <input
                            type="checkbox"
                            checked={selectedFirms.includes(client.client_id)}
                            onChange={() =>
                              handleCheckboxChange(client.client_id)
                            }
                          />
                        </td>
                        <td className="center-align">{client.serial_number}</td>
                        <td style={{ textAlign: 'center' }}>
                          {client.clients_company_name
                            ? client.clients_company_name
                              .toLowerCase()
                              .split(' ')
                              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')
                            : "NA"}
                        </td>
                          <td className="center-align">
                            <Tooltip
                              title={
                                <div style={{ textAlign: "left" }}>
                                  {" "}
                                  {/* Ensures left alignment */}
                                  <div>
                                    <strong>Email:</strong> {contactEmail}
                                  </div>
                                  <div>
                                    <strong>Address:</strong> {contactAddress}
                                  </div>
                                </div>
                              }
                              arrow
                              PopperProps={{
                                modifiers: [
                                  {
                                    name: "preventOverflow",
                                    options: {
                                      boundary: "window",
                                    },
                                  },
                                ],
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  justifyContent: "flex-start",
                                }}
                              >
                                {contactPersonName
                                  .toLowerCase()
                                  .split(' ')
                                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                  .join(' ')}
                                <span className="hover-icon"  style={{
    display: "flex",
    alignItems: "center",
  }}>
                                  <CiCircleInfo />
                                </span>
                              </span>
                            </Tooltip>
                          </td>

                        <td style={{ textAlign: 'left'}}>
                          {client.subsidiary_company
                            ? client.subsidiary_company
                              .toLowerCase()
                              .split(' ')
                              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')
                            : "NA"}
                        </td>
                        <td className="center-align">
                          <div className="action-btn">
                            <span
                              className="action-icon"
                              onClick={() => handleEdit(client.client_id)}
                            >
                              <CiEdit className="icn" />
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          {/* </div> */}
        </div>
        <Pagination
          className="client-pagination"
          total={totalRecords}
          showPerPage={itemsPerPage}
          onPaginationChange={handlePaginationChange}
        />
      </div>
    </div>
  );
};

export default ClientManagement;
